import { atom } from "jotai";

const foreverPromiseAtom = <T>() =>
  atom<T | Promise<T>>(new Promise<T>(() => {}));

export const ATOM_auth = foreverPromiseAtom<boolean>();
ATOM_auth.debugLabel = "ATOM_auth";
